import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { firestore as db } from "../config/Config";
import axios from 'axios';

const initialState = {
  materialData: [],
  materialModal: false,
  materialError: null,
};

// Create Materials Thunk
export const createMaterials = createAsyncThunk(
  "createMaterialList",
  async (allData, { rejectWithValue }) => {
    try {
      const docRef = db.collection(allData.table).doc(); // Generate new document ID
      await docRef.set({ ...allData, id: docRef.id }); // Add ID to Firestore
      return { ...allData, id: docRef.id }; // Return data with ID
    } catch (error) {
      console.error("Firestore error:", error);
      return rejectWithValue(error.message);
    }
  }
);

// Update Materials Thunk (Fixed)
export const updateMaterials = createAsyncThunk(
  "updateMaterialList",
  async (allData, { rejectWithValue }) => {
    try {
      const response = await axios.put(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/materialsUpdate/${allData.id}`, allData);
      if (response.status !== 200) {
        throw new Error('Failed to update material');
      }
      return response.data; // Return updated data
      
    } catch (error) {
      console.error("Update error:", error);
      return { id: allData.id, error: error.message }; // Return ID and error message
      
    }
      
  }

   
);

// delete item  Thunk 
export const deleteMaterials = createAsyncThunk(
  "deleteMaterial",
  async (item, { rejectWithValue }) => {
      try {
        const response = await axios.delete(`https://us-central1-fabdiz-quote.cloudfunctions.net/api/materialsDelete/${item.id}`);
        if (response.status !== 200) {
          throw new Error('Failed to delete material');
        }
        return { id: item.id }; // Return ID of deleted item
        
      } catch (error) {
        console.error("Delete error:", error);
        return { id: item.id, error: error.message }; // Return ID and error message
        
      }
  }
);

const addMaterialReducer = createSlice({
  name: "createMaterial",
  initialState,
  reducers: {},
 extraReducers: (builder) => {
  builder
    // CREATE
    .addCase(createMaterials.pending, (state) => {
      state.materialModal = false;
      state.materialError = null;
    })
    .addCase(createMaterials.fulfilled, (state, action) => {
      state.materialModal = true;

      const newMaterial = {
        ...action.payload,
        timestamp: action.payload.timestamp?.toDate
          ? action.payload.timestamp.toDate().toISOString()
          : action.payload.timestamp,
      };

      state.materialData.push(newMaterial);
    })
    .addCase(createMaterials.rejected, (state, action) => {
      state.materialModal = false;
      state.materialError = action.payload || "Failed to create material.";
    })

    // UPDATE
    .addCase(updateMaterials.pending, (state) => {
      state.materialModal = false;
      state.materialError = null;
    })
    .addCase(updateMaterials.fulfilled, (state, action) => {
      const updatedId = action.payload.id;
      const index = state.materialData.findIndex(item => item.id === updatedId);
      if (index !== -1) {
        state.materialData[index] = {
          ...state.materialData[index],
          ...action.payload,
        };
      }
    })
    .addCase(updateMaterials.rejected, (state, action) => {
      state.materialError = action.payload || "Failed to update material.";
    })

    // DELETE
    .addCase(deleteMaterials.fulfilled, (state, action) => {
      const deletedId = action.payload.id;
      state.materialData = state.materialData.filter(item => item.id !== deletedId);
    })
    .addCase(deleteMaterials.rejected, (state, action) => {
      state.materialError = action.payload || "Failed to delete material.";
    });
}

});

export default addMaterialReducer.reducer;
